module.exports = __webpack_public_path__ + "img/icon.1abce782.png";